var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Accordion, AccordionDetails, AccordionSummary, Grid, IconButton, Typography } from '@mui/material';
import { t } from 'i18next';
import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Get } from '../../../api/api';
import { CheckAlterNatePartsUrl, DeclinedJobReasonListUrl, getCustomerDeclinedJobswithPriceUrl, getJobCardSummaryByKey, PerodicPartsUrl, saveDeclinedPmPartsURl, upsertPMPartsUrl } from '../../../api/url';
import { CrossCircleGray, CrossCircleRed } from '../../../assets/images';
import { InputBox, MuiButton, MuiStack } from '../../../components';
import { MuiCheckBox } from '../../../components/atoms/checkBox';
import { MuiLoaderButton } from '../../../components/atoms/loaderButton';
import { MuiSelectComponent } from '../../../components/atoms/muiSelectComponent';
import SkeletonLoader from '../../../components/atoms/sketeton';
import { AlternatePartRelations, APISchema, EModuleSection, EParentModuleName, ESystemName, LOCAL_STORAGE_KEYS } from '../../../constants';
import { setIsTaskDetailsDataUpdated, setSavedTaskDetailsCount, setTaskDetailsDataSaved, setUpdatedModuleSectionByChannel, showLoader, showNotification } from '../../../redux/commonSlice';
import { createAPI, getByIdAPI, getListAPI, setState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { systemColor } from '../../../theme/systemColor';
import { getSupersadeAlternatePartMessage } from '../../../utils/utils';
import AlternatePartPopup from './taskDetailAccordians/alternatePartPopup';
import { getLocalStorageItem } from '../../../utils/storageHelper';
var RevisedEstimatePeriodicMaintainanceComponent = function (props) {
    var jobCardId = props.jobCardId, getSavedPeriodicPartsUrl = props.getSavedPeriodicPartsUrl, parentModuleName = props.parentModuleName, callApIStatus = props.callApIStatus, _a = props.isSaveButton, isSaveButton = _a === void 0 ? true : _a, isDisabled = props.isDisabled, SystemName = props.SystemName, RevisedEstimateId = props.RevisedEstimateId, alternatePartConfigState = props.alternatePartConfigState;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _b = useSelector(function (state) { return state.crud; }), ModuleDetailsGetById = _b.ModuleDetailsGetById, TaskDetailsSectionSave = _b.TaskDetailsSectionSave, getModuleHeaderCount = _b.getModuleHeaderCount;
    var _c = useState([]), pmPartsList = _c[0], setpmPartsList = _c[1];
    var _d = useState([]), rejectReasonRemarkList = _d[0], setRejectReasonRemarkList = _d[1];
    var _e = useSelector(function (state) { return state.common; }), accordianClosed = _e.accordianClosed, taskDetailDataSaved = _e.taskDetailDataSaved, updatedModuleSectionByChannel = _e.updatedModuleSectionByChannel;
    var _f = useState(false), disableSave = _f[0], setDisableSave = _f[1];
    var _g = useState(true), isSkeleton = _g[0], setIsSkeleton = _g[1];
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var _h = useState([]), pmPartsMasterList = _h[0], setPmPartsMasterList = _h[1];
    var _j = useState([]), declinedPmPartsList = _j[0], setDeclinedPmPartsList = _j[1];
    var _k = useState(false), alternetPartPopupOpen = _k[0], setAlternetPartPopupOpen = _k[1];
    var _l = useState([]), alterNatePartDetails = _l[0], setAlterNatePartDetails = _l[1];
    var _m = useState(null), searchedPart = _m[0], setSearchedPart = _m[1];
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var replacePart = function () {
        var alterNatePartItem = alterNatePartDetails.find(function (item) { return item.isChecked; });
        if (alterNatePartItem) {
            var index = pmPartsList.findIndex(function (item) { return item.ChildId === (searchedPart === null || searchedPart === void 0 ? void 0 : searchedPart.ChildId); });
            var list = __spreadArray([], pmPartsList, true);
            list[index] = _objectSpread(_objectSpread({}, list[index]), {}, {
                ChildId: alterNatePartItem.PartId,
                PartName: alterNatePartItem.PartName,
                HasAlternatePart: alterNatePartItem.AssociationName === AlternatePartRelations.TwoWay
            });
            setPmPartsMasterList(list);
        }
        setAlternetPartPopupOpen(false);
    };
    useEffect(function () {
        if (callApIStatus) {
            initiate();
        }
    }, [callApIStatus]);
    var initiate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, Promise.all([getRejectRemarkList(), getProductWisePmParts()])];
                case 1:
                    _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.log("error : initiate in RevisedEstimatePeriodicMaintainanceComponent", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getRejectRemarkList = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        Get(DeclinedJobReasonListUrl).then(function (response) {
                            if (response.success && response.data) {
                                setRejectReasonRemarkList(response.data);
                            }
                            resolve(response);
                        }).catch(function (getRejectRemarkListError) {
                            reject(getRejectRemarkListError);
                        });
                        return [2 /*return*/];
                    });
                }); })];
        });
    }); };
    var getProductWisePmParts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById, _ModuleDetailsGetById2, _ModuleDetailsGetById3, _ModuleDetailsGetById4, _ModuleDetailsGetById5, _ModuleDetailsGetById6, _savedJobCardPmPartsR, _savedJobCardPmPartsR2, _ModuleDetailsGetById11, _ModuleDetailsGetById12, _ModuleDetailsGetById13, _ModuleDetailsGetById14, _declinedPmPartsRespo, _declinedPmPartsRespo2, requestBody, response, request, _ModuleDetailsGetById7, _ModuleDetailsGetById8, _ModuleDetailsGetById9, _ModuleDetailsGetById10, savedJobCardPmPartsPayload, savedJobCardPmPartsResponse, savedJobCardsPms, _savedJobCardPmPartsR3, declineJobRequestBody, declinedPmPartsResponse, _declinedPmPartsRespo3, _declinedPmPartsRespo4, declinesPmParts_1, PmTotalPrice_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        "Usage": Number(ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById === void 0 ? void 0 : _ModuleDetailsGetById.ODOMeterReading),
                        "VinNo": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById2 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById2 === void 0 ? void 0 : _ModuleDetailsGetById2.VinNo,
                        "RepairTypeId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById3 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById3 === void 0 ? void 0 : _ModuleDetailsGetById3.RepairTypeId,
                        "InstallBaseId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById4 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById4 === void 0 ? void 0 : _ModuleDetailsGetById4.InstallBaseId,
                        "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        "PreJobCardDocumentId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById5 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById5 === void 0 ? void 0 : _ModuleDetailsGetById5.id,
                        "Entity": ESystemName.Estimate
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: PerodicPartsUrl,
                            request: requestBody
                        }))];
                case 1:
                    response = _a.sent();
                    request = {
                        RepairTypeId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById6 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById6 === void 0 ? void 0 : _ModuleDetailsGetById6.RepairTypeId
                    };
                    if (parentModuleName === EParentModuleName.Appointment) {
                        request.AppointmentId = jobCardId;
                    }
                    if (parentModuleName === EParentModuleName.ServiceEstimate) {
                        request.EstimateId = jobCardId;
                        request.VinNo = ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById7 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById7 === void 0 ? void 0 : _ModuleDetailsGetById7.VinNo;
                        request.OrganizationId = ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById8 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById8 === void 0 ? void 0 : _ModuleDetailsGetById8.OrganizationId;
                    }
                    if (parentModuleName === EParentModuleName.Inspection) {
                        request.InspectionId = jobCardId;
                        request.VinNo = ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById9 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById9 === void 0 ? void 0 : _ModuleDetailsGetById9.VinNo;
                        request.OrganizationId = ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById10 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById10 === void 0 ? void 0 : _ModuleDetailsGetById10.OrganizationId;
                    }
                    savedJobCardPmPartsPayload = {
                        JobCardId: jobCardId,
                        Key: "PERIODIC_MAINTENANCE"
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: getJobCardSummaryByKey,
                            request: savedJobCardPmPartsPayload
                        }))];
                case 2:
                    savedJobCardPmPartsResponse = _a.sent();
                    savedJobCardsPms = [];
                    if (savedJobCardPmPartsResponse !== null && savedJobCardPmPartsResponse !== void 0 && (_savedJobCardPmPartsR = savedJobCardPmPartsResponse.payload) !== null && _savedJobCardPmPartsR !== void 0 && _savedJobCardPmPartsR.data && (savedJobCardPmPartsResponse === null || savedJobCardPmPartsResponse === void 0 || (_savedJobCardPmPartsR2 = savedJobCardPmPartsResponse.payload) === null || _savedJobCardPmPartsR2 === void 0 ? void 0 : _savedJobCardPmPartsR2.statusCode) == 200) {
                        savedJobCardPmPartsResponse === null || savedJobCardPmPartsResponse === void 0 || (_savedJobCardPmPartsR3 = savedJobCardPmPartsResponse.payload) === null || _savedJobCardPmPartsR3 === void 0 || (_savedJobCardPmPartsR3 = _savedJobCardPmPartsR3.data) === null || _savedJobCardPmPartsR3 === void 0 || (_savedJobCardPmPartsR3 = _savedJobCardPmPartsR3.Jobs) === null || _savedJobCardPmPartsR3 === void 0 || _savedJobCardPmPartsR3.map(function (item) {
                            var _item$Price;
                            var updatedItem = _objectSpread({}, item);
                            updatedItem.isExpanded = false;
                            updatedItem.jobType = item.ChildSystemName === "Labour" ? "Labour" : "Part";
                            updatedItem.isSelectedInJobCard = true;
                            updatedItem.Price = Number((_item$Price = item === null || item === void 0 ? void 0 : item.Price) !== null && _item$Price !== void 0 ? _item$Price : 0) * Number(item === null || item === void 0 ? void 0 : item.Quantity);
                            if (updatedItem.jobType === "Labour") {
                                updatedItem.LabourName = item.ChildName;
                            }
                            else {
                                updatedItem.PartName = item.ChildName;
                            }
                            savedJobCardsPms.push(updatedItem);
                        });
                    }
                    declineJobRequestBody = {
                        "ParentId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById11 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById11 === void 0 ? void 0 : _ModuleDetailsGetById11.ParentId,
                        "InstallBaseId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById12 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById12 === void 0 ? void 0 : _ModuleDetailsGetById12.InstallBaseId,
                        "ServiceDetailType": 3,
                        "OrganizationId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById13 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById13 === void 0 ? void 0 : _ModuleDetailsGetById13.OrganizationId,
                        "VinNo": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById14 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById14 === void 0 ? void 0 : _ModuleDetailsGetById14.VinNo
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: getCustomerDeclinedJobswithPriceUrl,
                            request: declineJobRequestBody
                        }))];
                case 3:
                    declinedPmPartsResponse = _a.sent();
                    if ((_declinedPmPartsRespo = declinedPmPartsResponse.payload) !== null && _declinedPmPartsRespo !== void 0 && (_declinedPmPartsRespo = _declinedPmPartsRespo.value) !== null && _declinedPmPartsRespo !== void 0 && _declinedPmPartsRespo.success && (_declinedPmPartsRespo2 = declinedPmPartsResponse.payload) !== null && _declinedPmPartsRespo2 !== void 0 && (_declinedPmPartsRespo2 = _declinedPmPartsRespo2.value) !== null && _declinedPmPartsRespo2 !== void 0 && _declinedPmPartsRespo2.data) {
                        declinesPmParts_1 = [];
                        declinedPmPartsResponse === null || declinedPmPartsResponse === void 0 || (_declinedPmPartsRespo3 = declinedPmPartsResponse.payload) === null || _declinedPmPartsRespo3 === void 0 || (_declinedPmPartsRespo3 = _declinedPmPartsRespo3.value) === null || _declinedPmPartsRespo3 === void 0 || (_declinedPmPartsRespo3 = _declinedPmPartsRespo3.data) === null || _declinedPmPartsRespo3 === void 0 || (_declinedPmPartsRespo3 = _declinedPmPartsRespo3.Labour) === null || _declinedPmPartsRespo3 === void 0 || _declinedPmPartsRespo3.map(function (item) {
                            var updatedItem = _objectSpread({}, item);
                            updatedItem.jobType = "Labour";
                            updatedItem.isExpanded = true;
                            updatedItem.DeclinedRemarks = item.Remarks ? item.Remarks : "";
                            updatedItem.RejectReasonRemark = item.DeclinedJobReasonId ? item.DeclinedJobReasonId : "";
                            declinesPmParts_1.push(updatedItem);
                        });
                        declinedPmPartsResponse === null || declinedPmPartsResponse === void 0 || (_declinedPmPartsRespo4 = declinedPmPartsResponse.payload) === null || _declinedPmPartsRespo4 === void 0 || (_declinedPmPartsRespo4 = _declinedPmPartsRespo4.value) === null || _declinedPmPartsRespo4 === void 0 || (_declinedPmPartsRespo4 = _declinedPmPartsRespo4.data) === null || _declinedPmPartsRespo4 === void 0 || _declinedPmPartsRespo4.Part.map(function (item) {
                            var updatedItem = _objectSpread({}, item);
                            updatedItem.jobType = "Part";
                            updatedItem.isExpanded = true;
                            updatedItem.DeclinedRemarks = item.Remarks ? item.Remarks : "";
                            updatedItem.RejectReasonRemark = item.DeclinedJobReasonId ? item.DeclinedJobReasonId : "";
                            declinesPmParts_1.push(updatedItem);
                        });
                        setIsSkeleton(false);
                        setpmPartsList(__spreadArray(__spreadArray([], savedJobCardsPms, true), declinesPmParts_1, true));
                        PmTotalPrice_1 = 0;
                        savedJobCardsPms.map(function (item) {
                            if (!(item !== null && item !== void 0 && item.isExpanded)) {
                                var _item$SelectedPriceDe, _item$SelectedPriceDe2;
                                var amount = item !== null && item !== void 0 && (_item$SelectedPriceDe = item.SelectedPriceDetails) !== null && _item$SelectedPriceDe !== void 0 && _item$SelectedPriceDe.Amount ? item === null || item === void 0 || (_item$SelectedPriceDe2 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe2 === void 0 ? void 0 : _item$SelectedPriceDe2.Amount : 0;
                                PmTotalPrice_1 += amount;
                            }
                        });
                        dispatch(setState({
                            key: "TotalPMPartPrice",
                            value: PmTotalPrice_1
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSelectPMPartsRejectReason = function (event, index) {
        var _event$target$value, _event$target;
        var updatedList = __spreadArray([], pmPartsList, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.RejectReasonRemark = (_event$target$value = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) !== null && _event$target$value !== void 0 ? _event$target$value : "";
        updatedList[index] = updatedItem;
        setpmPartsList(updatedList);
        dispatch(setIsTaskDetailsDataUpdated(true));
        setDisableSave(false);
    };
    var handleChangeRejectRemark = function (event, index) {
        var _event$target$value2, _event$target2;
        var updatedList = __spreadArray([], pmPartsList, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.DeclinedRemarks = (_event$target$value2 = (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value) !== null && _event$target$value2 !== void 0 ? _event$target$value2 : "";
        updatedList[index] = updatedItem;
        setpmPartsList(updatedList);
        dispatch(setIsTaskDetailsDataUpdated(true));
        setDisableSave(false);
    };
    var savePMParts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById15, _ModuleDetailsGetById17, _saveDeclinedPmPartsR, _response$payload, _response$payload2, SavedPMParts, requestBody, declinedPMParts, saveDeclinedJobsPayload, saveDeclinedPmPartsResponse, response, updatedTaskDetailsSectionSave, sortedList_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    SavedPMParts = [];
                    pmPartsList.map(function (item) {
                        if (!item.isExpanded && !item.isSelectedInJobCard) {
                            SavedPMParts.push({
                                Quantity: item.Quantity,
                                SystemName: item.jobType === "Labour" ? "Labour" : "Product",
                                ChildId: item.ChildId,
                                Price: item.SelectedPriceDetails
                            });
                        }
                    });
                    requestBody = {
                        "PeriodicParts": SavedPMParts,
                        "RepairTypeId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById15 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById15 === void 0 ? void 0 : _ModuleDetailsGetById15.RepairTypeId,
                        EstimateId: RevisedEstimateId
                    };
                    declinedPMParts = [];
                    pmPartsList.map(function (item) {
                        if (item.isExpanded) {
                            var _item$DeclinedRemarks, _ModuleDetailsGetById16;
                            declinedPMParts.push({
                                SystemName: item.jobType === "Labour" ? "Labour" : "Product",
                                ChildId: item.ChildId,
                                DeclineDateTime: new Date(),
                                Remarks: (_item$DeclinedRemarks = item.DeclinedRemarks) !== null && _item$DeclinedRemarks !== void 0 ? _item$DeclinedRemarks : "",
                                ServiceTypeId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById16 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById16 === void 0 ? void 0 : _ModuleDetailsGetById16.RepairTypeId,
                                DeclinedJobReasonId: item.RejectReasonRemark,
                                ServiceDetailType: 3,
                                ParentSystemName: SystemName,
                                Quantity: item.Quantity,
                                Price: item.Price
                            });
                        }
                    });
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    saveDeclinedJobsPayload = {
                        "InstallBaseId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById17 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById17 === void 0 ? void 0 : _ModuleDetailsGetById17.InstallBaseId,
                        "DeclinedJobs": declinedPMParts,
                        "ParentId": jobCardId,
                        ServiceDetailType: 3
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "declinedPmParts",
                            url: saveDeclinedPmPartsURl,
                            request: saveDeclinedJobsPayload
                        }))];
                case 1:
                    saveDeclinedPmPartsResponse = _a.sent();
                    if (saveDeclinedPmPartsResponse && (_saveDeclinedPmPartsR = saveDeclinedPmPartsResponse.payload) !== null && _saveDeclinedPmPartsR !== void 0 && _saveDeclinedPmPartsR.value) {
                        setDeclinedPmPartsList(declinedPMParts);
                    }
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: upsertPMPartsUrl(APISchema.Estimate),
                            request: requestBody
                        }))];
                case 2:
                    response = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (response !== null && response !== void 0 && (_response$payload = response.payload) !== null && _response$payload !== void 0 && (_response$payload = _response$payload.value) !== null && _response$payload !== void 0 && _response$payload.success && (response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.value) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.statusCode) == 200) {
                        setDisableSave(true);
                        getProductWisePmParts();
                        dispatch(setSavedTaskDetailsCount({
                            periodicMaintenanceCount: SavedPMParts.length
                        }));
                        dispatch(setState({
                            key: "getModuleHeaderCount",
                            value: _objectSpread(_objectSpread({}, getModuleHeaderCount), {}, {
                                PeriodicParts: SavedPMParts.length,
                                CustomerDeclinedJobs: declinedPMParts.length
                            })
                        }));
                        updatedTaskDetailsSectionSave = _objectSpread({}, TaskDetailsSectionSave);
                        updatedTaskDetailsSectionSave.periodicMaintainance = true;
                        dispatch(setState({
                            key: "TaskDetailsSectionSave",
                            value: updatedTaskDetailsSectionSave
                        }));
                        dispatch(setTaskDetailsDataSaved(true));
                        sortedList_1 = [];
                        updatedModuleSectionByChannel.map(function (item) {
                            var data = cloneDeep(item);
                            if (item.Key == EModuleSection.PeriodicMaintenance) {
                                // data.SectionAttributes[0].MANDATORY = response?.payload?.value?.data?.PeriodicParts?.length > 0 ? true : false
                                // data.SectionAttributes[0].MANDATORYDefaultValue = response?.payload?.value?.data?.PeriodicParts?.length > 0 ? true : false
                            }
                            sortedList_1.push(data);
                        });
                        dispatch(setUpdatedModuleSectionByChannel(sortedList_1));
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("Periodic parts saved successfully"),
                            type: "success"
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var onClickSave = function () {
        savePMParts();
    };
    var onClickAccordianIcon = function (index) {
        var updatedList = __spreadArray([], pmPartsList, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.isExpanded = !updatedItem.isExpanded;
        if (!updatedItem.isExpanded) {
            updatedItem.RejectReasonRemark = "";
            updatedItem.DeclinedRemarks = "";
        }
        updatedList[index] = updatedItem;
        if (!updatedItem.isExpanded) {
            setDisableSave(false);
        }
        setpmPartsList(updatedList);
    };
    var getSaveDisable = function () {
        var expandedItems = pmPartsList.filter(function (item) { return item.isExpanded; });
        if (expandedItems.length > 0) {
            var isAllExpandedValuesFilled = Object.values(expandedItems).every(function (item) { return item.RejectReasonRemark; });
            return !isAllExpandedValuesFilled;
        }
        else {
            return false;
        }
    };
    var handleALternatePartClick = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById18, _ModuleDetailsGetById19, alterNatePartPayload, result, _result$payload$data, alternateParts, alternatePartItem, index, list;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    alterNatePartPayload = {
                        "PartId": item.ChildId,
                        OrganizationId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById18 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById18 === void 0 ? void 0 : _ModuleDetailsGetById18.OrganizationId,
                        VinNo: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById19 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById19 === void 0 ? void 0 : _ModuleDetailsGetById19.VinNo
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "",
                            url: CheckAlterNatePartsUrl,
                            request: alterNatePartPayload
                        }))];
                case 1:
                    result = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (result && result.payload && result.payload.success) {
                        alternateParts = (_result$payload$data = result.payload.data) !== null && _result$payload$data !== void 0 ? _result$payload$data : [];
                        alternatePartItem = alternateParts.find(function (item) { return item.AssociationName === AlternatePartRelations.Superseds; });
                        if (alternatePartItem) {
                            index = pmPartsList.findIndex(function (item) { return item.ChildId === (searchedPart === null || searchedPart === void 0 ? void 0 : searchedPart.ChildId); });
                            if (index > 0) {
                                list = __spreadArray([], pmPartsList, true);
                                list[index] = _objectSpread(_objectSpread({}, list[index]), {}, {
                                    ChildId: alternatePartItem.PartId,
                                    PartName: alternatePartItem.PartName,
                                    HasAlternatePart: alternatePartItem.AssociationName === AlternatePartRelations.TwoWay
                                });
                                setPmPartsMasterList(list);
                                dispatch(showNotification({
                                    isOpen: true,
                                    message: getSupersadeAlternatePartMessage(alternatePartItem.PartName, item.PartName),
                                    type: "success"
                                }));
                            }
                        }
                        else {
                            setAlterNatePartDetails(alternateParts);
                            setAlternetPartPopupOpen(alternateParts.length > 0);
                            setSearchedPart(_objectSpread(_objectSpread({}, item), {}, {
                                isChecked: true
                            }));
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return /*#__PURE__*/ React.createElement("div", null, pmPartsList.length > 0 ? /*#__PURE__*/ React.createElement(React.Fragment, null, pmPartsList === null || pmPartsList === void 0 ? void 0 : pmPartsList.map(function (item, index) {
        var _item$jobType, _item$RejectReasonRem, _item$DeclinedRemarks2;
        console.log(item.HasAlternatePart);
        return /*#__PURE__*/ React.createElement(MuiStack, {
            key: index,
            sx: {
                "& .Mui-expanded": {
                    transform: "none",
                    backgroundColor: "#EFF2F5"
                }
            }
        }, /*#__PURE__*/ React.createElement(Accordion, {
            expanded: item.isExpanded,
            id: "pmParts-accordian-".concat(index),
            style: {
                width: '100%',
                boxShadow: 'none',
                borderRadius: '8px'
            }
        }, /*#__PURE__*/ React.createElement(AccordionSummary, {
            expandIcon: !item.isSelectedInJobCard && /*#__PURE__*/ React.createElement(IconButton, {
                disabled: isDisabled,
                onClick: function () { return onClickAccordianIcon(index); }
            }, /*#__PURE__*/ React.createElement("img", {
                alt: "cross",
                src: item.isExpanded ? CrossCircleRed : CrossCircleGray,
                style: {
                    opacity: isDisabled ? 0.7 : 1
                }
            })),
            "aria-controls": "panel".concat(index, "a-content"),
            id: "panel".concat(index, "a-header"),
            style: {
                opacity: item.isSelectedInJobCard ? 0.5 : 1
            },
            disabled: item.isSelectedInJobCard
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: 'space-between',
            width: "100%",
            paddingRight: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            alignItems: 'center',
            width: '100%'
        }, /*#__PURE__*/ React.createElement(MuiCheckBox, {
            id: "service-type-checkbox",
            sx: {
                "& .MuiCheckbox-root": {
                    paddingY: 0,
                    paddingLeft: '4px',
                    paddingRight: '0px',
                    '&.Mui-disabled': {
                        color: item.isExpanded ? "#A8B5C2" : "#95DE64"
                    }
                }
            },
            disabled: true,
            checkBoxValue: true
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            width: '100%',
            spacing: 1.25,
            alignItems: 'center',
            justifyContent: 'space-between'
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column'
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: 'flex-start',
            alignItems: "flex-start"
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3",
            sx: {
                textTransform: 'capitalize'
            }
        }, item.PartName ? item.PartName : item.LabourName)), /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: 'flex-start',
            alignItems: "flex-start",
            onClick: function () { }
        }, !item.isExpanded && item.HasAlternatePart && alternatePartConfigState["Periodic Maintenance"] && /*#__PURE__*/ React.createElement(MuiButton, {
            name: "Alternate Part",
            variant: "text",
            size: "small",
            sx: {
                bgcolor: "transparent",
                minWidth: 'auto',
                padding: 0
            },
            onClick: function () {
                handleALternatePartClick(item);
            }
        }))), /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                backgroundColor: "#EEF6FF",
                padding: "3px 8px",
                borderRadius: "12px",
                border: '1px solid #AFD5FF',
                justifyContent: 'center'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                color: systemColor.primary
            },
            variant: "h5"
        }, (_item$jobType = item.jobType) === null || _item$jobType === void 0 ? void 0 : _item$jobType.substring(0, 1))))))), /*#__PURE__*/ React.createElement(AccordionDetails, null, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 2,
            direction: 'column'
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            bgcolor: 'white',
            borderRadius: '8px'
        }, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
            id: "reject-reason-dropdown",
            margin: 0,
            fullWidth: true,
            options: rejectReasonRemarkList || [],
            caption: "reason for rejection",
            displayExpr: "DisplayName",
            valueExpr: "id",
            name: "rejectReason",
            value: (_item$RejectReasonRem = item.RejectReasonRemark) !== null && _item$RejectReasonRem !== void 0 ? _item$RejectReasonRem : "",
            onChange: function (event) { return handleSelectPMPartsRejectReason(event, index); },
            disabled: isDisabled
        })), /*#__PURE__*/ React.createElement(MuiStack, {
            bgcolor: 'white',
            borderRadius: '8px'
        }, /*#__PURE__*/ React.createElement(InputBox
        // sx={{ height: '44px' }}
        , {
            id: "remark-input",
            placeholder: t("ENTER_REMARKS_PLACEHOLDER"),
            onChange: function (event) { return handleChangeRejectRemark(event, index); },
            fullWidth: true,
            size: "small",
            value: (_item$DeclinedRemarks2 = item.DeclinedRemarks) !== null && _item$DeclinedRemarks2 !== void 0 ? _item$DeclinedRemarks2 : "",
            disabled: isDisabled
        }))))));
    })) : /*#__PURE__*/ React.createElement(React.Fragment, null, !isSkeleton && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        paddingBottom: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h2"
    }, pmPartsMasterList.length > 0 && pmPartsMasterList.length === declinedPmPartsList.length ? t("ALL_PM_DECLINED_MESSAGE") : t("No Data Found"), "..!!")))), isSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        style: {
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), isSaveButton && /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        justifyContent: "flex-end",
        marginTop: "10px"
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        variant: "contained",
        loading: loader.isLoaderOpen,
        name: t('Save'),
        disabled: pmPartsList.length === 0 || isDisabled || disableSave,
        onClick: onClickSave
    })), /*#__PURE__*/ React.createElement(AlternatePartPopup, {
        alternetPartPopupOpen: alternetPartPopupOpen,
        setAlternetPartPopupOpen: setAlternetPartPopupOpen,
        replacePart: replacePart,
        searchedPart: searchedPart,
        setSearchedPart: setSearchedPart,
        alterNatePartDetails: alterNatePartDetails,
        setAlterNatePartDetails: setAlterNatePartDetails
    }));
};
export default RevisedEstimatePeriodicMaintainanceComponent;
